import { useAuth } from '@/contexts/AuthContext';
import { DebugJson, DebugKv, DebugSection } from '../DebugSection';

export interface IdentitySectionProps { searchTerm?: string }

export function IdentitySection({ searchTerm }: IdentitySectionProps): JSX.Element {
  const { user, token, isInTeams } = useAuth();
  const teamsCtx = (typeof window !== 'undefined' && window.__PCB_DEBUG_EXTRA__?.['teamsContext']) ?? null;

  const rows = [
    { k: 'upn', v: user?.upn },
    { k: 'displayName', v: user?.displayName },
    { k: 'primaryRole', v: user?.primaryRole },
    { k: 'roles', v: user?.roles?.join(', ') },
    { k: 'tenantId', v: user?.tenantId },
    { k: 'officerCode', v: user?.officerCode },
    { k: 'officerTeam', v: user?.officerTeam },
    { k: 'effectiveLevel', v: user?.effectiveLevel },
    { k: 'primaryBranchCode', v: user?.primaryBranchCode },
    { k: 'primaryBranchName', v: user?.primaryBranchName },
    { k: 'activeBranchCode', v: user?.activeBranchCode },
    { k: 'activeBranchName', v: user?.activeBranchName },
    { k: 'overrideActive', v: user?.overrideActive },
    { k: 'overrideSetAt', v: user?.overrideSetAt },
    { k: 'overrideReason', v: user?.overrideReason },
    { k: 'regionCode', v: user?.regionCode },
    { k: 'subordinatesEmails', v: user?.subordinatesEmails?.length },
    // nmlsId + appDepartment dropped 2026-05-14.
    { k: 'status', v: user?.status },
    { k: 'isInTeams', v: isInTeams },
    { k: 'hasToken', v: Boolean(token) },
    { k: 'tokenLength', v: token?.length },
  ];

  return (
    <DebugSection id="identity" title="1. Identity + auth" searchTerm={searchTerm}>
      <DebugKv rows={rows} searchTerm={searchTerm} />
      {user?.permissions && Object.keys(user.permissions).length > 0 && (
        <details className="pcb-debug-details">
          <summary>permissions ({Object.keys(user.permissions).length})</summary>
          <DebugJson value={user.permissions} searchTerm={searchTerm} />
        </details>
      )}
      {teamsCtx ? (
        <details className="pcb-debug-details">
          <summary>Teams context</summary>
          <DebugJson value={teamsCtx} searchTerm={searchTerm} />
        </details>
      ) : null}
    </DebugSection>
  );
}
